import type { DutyRecurrenceFrequency } from './duty-recurrence.model';

export interface PredefinedRoutineItem {
  titleKey: string;
  contentKey: string;
  rewardXp?: number;
  recurrenceFrequency?: DutyRecurrenceFrequency;
}

export interface PredefinedRoutine {
  id: string;
  nameKey: string;
  hintKey: string;
  items: PredefinedRoutineItem[];
}

/** Curated ritual starters — trust-framed, common family agreements. */
export const PREDEFINED_ROUTINES: PredefinedRoutine[] = [
  {
    id: 'evening',
    nameKey: 'app.components.routinesDialog.starters.evening.name',
    hintKey: 'app.components.routinesDialog.starters.evening.hint',
    items: [
      {
        titleKey: 'app.components.routinesDialog.starters.evening.items.bed.title',
        contentKey:
          'app.components.routinesDialog.starters.evening.items.bed.content',
        recurrenceFrequency: 'DAILY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.evening.items.homework.title',
        contentKey:
          'app.components.routinesDialog.starters.evening.items.homework.content',
        recurrenceFrequency: 'DAILY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.evening.items.teeth.title',
        contentKey:
          'app.components.routinesDialog.starters.evening.items.teeth.content',
        recurrenceFrequency: 'DAILY',
      },
    ],
  },
  {
    id: 'morning',
    nameKey: 'app.components.routinesDialog.starters.morning.name',
    hintKey: 'app.components.routinesDialog.starters.morning.hint',
    items: [
      {
        titleKey:
          'app.components.routinesDialog.starters.morning.items.dressed.title',
        contentKey:
          'app.components.routinesDialog.starters.morning.items.dressed.content',
        recurrenceFrequency: 'DAILY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.morning.items.breakfast.title',
        contentKey:
          'app.components.routinesDialog.starters.morning.items.breakfast.content',
        recurrenceFrequency: 'DAILY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.morning.items.bag.title',
        contentKey:
          'app.components.routinesDialog.starters.morning.items.bag.content',
        recurrenceFrequency: 'DAILY',
      },
    ],
  },
  {
    id: 'afterSchool',
    nameKey: 'app.components.routinesDialog.starters.afterSchool.name',
    hintKey: 'app.components.routinesDialog.starters.afterSchool.hint',
    items: [
      {
        titleKey:
          'app.components.routinesDialog.starters.afterSchool.items.wash.title',
        contentKey:
          'app.components.routinesDialog.starters.afterSchool.items.wash.content',
        recurrenceFrequency: 'DAILY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.afterSchool.items.snack.title',
        contentKey:
          'app.components.routinesDialog.starters.afterSchool.items.snack.content',
        recurrenceFrequency: 'DAILY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.afterSchool.items.homework.title',
        contentKey:
          'app.components.routinesDialog.starters.afterSchool.items.homework.content',
        recurrenceFrequency: 'DAILY',
      },
    ],
  },
  {
    id: 'weekendTidy',
    nameKey: 'app.components.routinesDialog.starters.weekendTidy.name',
    hintKey: 'app.components.routinesDialog.starters.weekendTidy.hint',
    items: [
      {
        titleKey:
          'app.components.routinesDialog.starters.weekendTidy.items.room.title',
        contentKey:
          'app.components.routinesDialog.starters.weekendTidy.items.room.content',
        recurrenceFrequency: 'WEEKLY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.weekendTidy.items.laundry.title',
        contentKey:
          'app.components.routinesDialog.starters.weekendTidy.items.laundry.content',
        recurrenceFrequency: 'WEEKLY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.weekendTidy.items.help.title',
        contentKey:
          'app.components.routinesDialog.starters.weekendTidy.items.help.content',
        recurrenceFrequency: 'WEEKLY',
      },
    ],
  },
  {
    id: 'screenBalance',
    nameKey: 'app.components.routinesDialog.starters.screenBalance.name',
    hintKey: 'app.components.routinesDialog.starters.screenBalance.hint',
    items: [
      {
        titleKey:
          'app.components.routinesDialog.starters.screenBalance.items.plan.title',
        contentKey:
          'app.components.routinesDialog.starters.screenBalance.items.plan.content',
        recurrenceFrequency: 'WEEKLY',
      },
      {
        titleKey:
          'app.components.routinesDialog.starters.screenBalance.items.charge.title',
        contentKey:
          'app.components.routinesDialog.starters.screenBalance.items.charge.content',
        recurrenceFrequency: 'DAILY',
      },
    ],
  },
];

export type RoutineSelection =
  | { kind: 'starter'; starterId: string }
  | { kind: 'saved'; templateId: string };
